export enum RestorableStateTypes {
    New = "new",
    Mismatch = "mismatch",
    Restorable = "retorable",
}
